import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SafeHtml} from '@angular/platform-browser';
import {BehaviorSubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {MxButtonModel} from '../../../mx-button/components/mx-button.model';

export class MxErrorDialogData {
    title?: string;
    message?: string | SafeHtml;
    type?: 'error' | 'warn' | 'accent' | 'info' = 'info';
}

@Component({
    selector: 'mx-error-dialog',
    standalone: false,
    templateUrl: './mx-error-dialog.component.html',
    styleUrls: ['./mx-error-dialog.component.scss']
})

export class MxErrorDialogComponent implements OnInit, OnDestroy {
    public okButton: MxButtonModel;
    private _destroy$$: Subject<null> = new Subject<null>();
    errorDialogData: Array<MxErrorDialogData> = [];

    constructor(
        private dialogRef: MatDialogRef<MxErrorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: BehaviorSubject<MxErrorDialogData>
    ) {
        this.data.pipe(takeUntil(this._destroy$$)).subscribe(message => {
            this.errorDialogData.push(message);
        });
    }

    ngOnInit(): void {
        this.okButton = {
            label: 'Ok',
            tooltip: 'Ok',
            className: 'mxs-button--primary',
            clickHandler: () => {
                this.dialogRef.close(true);
            }
        };
    }

    ngOnDestroy(): void {
        this._destroy$$.next(null);
    }
}
